<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="case-4">
<h1>Case 4</h1>
<div class="section level21" id="clinical-presentation-3">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Clinical Presentation</p>
<p style="text-indent:0px;">A 40-year-old man presented with acute onset of severe lower abdominal pain, nausea and vomiting with a palpable mid-pelvic mass.</p>
</div>
<div class="section level21" id="radiological-findings-3">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Radiological Findings</p>
<p style="text-indent: 0px; text-align: center;"><img alt="4" src="media/4.png"/></p>
<p style="padding-top: 15px;padding-bottom:10px; text-align: center;"></p>
<ul style="list-style:none;padding-right:95px;padding-left:110px;margin-top:0px;"><li>
<p style="text-indent:20px;"><strong>Enhanced Abdominal CT scan, axial (A, B, C) with coronal / sagittal reconstruction (D, E, F) images</strong> showing a sausage-shaped mid-pelvic mass with central area containing mesenteric fat and vessels indicating intussusception. Distal within this mass there is a well-defined fatty-density lesion (arrow images, C, E and F) representing a lipoma. Note proximal small bowel dilatation.</p>
</li></ul>
<p style="text-indent:0px;padding-top:15px;"><strong>Diagnosis:</strong> Ileo-ileal Intussusception Secondary to a Lipoma</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?4d3b3a6e